import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-973e22bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gd-cctv-details mb-gutter" }
const _hoisted_2 = { class: "mb-gutter" }
const _hoisted_3 = { class: "form-field form-field--gd--full" }
const _hoisted_4 = { class: "field-row" }
const _hoisted_5 = { class: "form-field form-field--gd" }
const _hoisted_6 = { class: "field-row" }
const _hoisted_7 = {
  class: "label label--text label--inline",
  "data-auto": "cctvdetails-lbl"
}
const _hoisted_8 = { class: "gd-field-multi-select form-field--gd__options" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "css-radio" }, null, -1))
const _hoisted_11 = {
  class: "label label--inline label-padding",
  "data-auto": "cctvdetails-yes-lbl"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "css-radio" }, null, -1))
const _hoisted_14 = {
  class: "label label--inline label-padding",
  "data-auto": "cctvdetails-no-lbl"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "form-field form-field--gd" }
const _hoisted_17 = { class: "field-row" }
const _hoisted_18 = {
  class: "label label--text label--inline",
  "data-auto": "cctvstorevehicle-lbl"
}
const _hoisted_19 = { class: "gd-field-multi-select form-field--gd__options" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "css-checkbox" }, null, -1))
const _hoisted_22 = {
  class: "label label--inline label-padding",
  "data-auto": "cctvstorevehicle-IsCCTVStore-lbl"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "css-checkbox" }, null, -1))
const _hoisted_25 = {
  class: "label label--inline label-padding",
  "data-auto": "cctvstorevehicle-IsCCTVCarPark-lbl"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "form-field form-field--gd" }
const _hoisted_28 = { class: "field-row" }
const _hoisted_29 = {
  class: "label label--text label--inline",
  "data-auto": "storepostcode-lbl"
}
const _hoisted_30 = ["disabled", "placeholder"]
const _hoisted_31 = { class: "tooltip-icon tooltip-icon-label" }
const _hoisted_32 = { "data-auto": "StorePostCodeInfo-btn" }
const _hoisted_33 = { class: "form-field form-field--gd" }
const _hoisted_34 = { class: "field-row" }
const _hoisted_35 = {
  class: "label label--text label--inline",
  "data-auto": "storedateofvisit-lbl"
}
const _hoisted_36 = { class: "form-field form-field--gd" }
const _hoisted_37 = { class: "field-row" }
const _hoisted_38 = {
  class: "label label--text label--inline",
  "data-auto": "startvisittime-lbl"
}
const _hoisted_39 = { class: "gd-field-multi-select gd-field-multi-select--time" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { value: "" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { value: "" }
const _hoisted_44 = { class: "form-field form-field--gd" }
const _hoisted_45 = { class: "field-row" }
const _hoisted_46 = {
  class: "label label--text label--inline",
  "data-auto": "endvisittime-lbl"
}
const _hoisted_47 = { class: "gd-field-multi-select gd-field-multi-select--time" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { value: "" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = { value: "" }
const _hoisted_52 = { class: "form-field form-field--gd" }
const _hoisted_53 = { class: "field-row" }
const _hoisted_54 = {
  class: "label label--text label--inline",
  "data-auto": "addinfo-lbl"
}
const _hoisted_55 = ["placeholder", "disabled"]
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { class: "form-field form-field--gd" }
const _hoisted_58 = { class: "field-row" }
const _hoisted_59 = {
  class: "label label--text label--inline",
  "data-auto": "vehiclemake-lbl"
}
const _hoisted_60 = ["disabled", "placeholder"]
const _hoisted_61 = { class: "form-field form-field--gd" }
const _hoisted_62 = { class: "field-row" }
const _hoisted_63 = {
  class: "label label--text label--inline",
  "data-auto": "vehiclemodel-lbl"
}
const _hoisted_64 = ["disabled", "placeholder"]
const _hoisted_65 = { class: "form-field form-field--gd" }
const _hoisted_66 = { class: "field-row" }
const _hoisted_67 = {
  class: "label label--text label--inline",
  "data-auto": "vehiclecolour-lbl"
}
const _hoisted_68 = ["disabled", "placeholder"]
const _hoisted_69 = { class: "form-field form-field--gd" }
const _hoisted_70 = { class: "field-row" }
const _hoisted_71 = {
  class: "label label--text label--inline",
  "data-auto": "vehicleregnumber-lbl"
}
const _hoisted_72 = ["disabled", "placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_date_picker = _resolveComponent("date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(`${_ctx.translate("labeltext.partB")}${_ctx.translate(
            "labeltext.cctvHeader"
          )}`), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("labeltext.cctvHelpfulText")), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("labeltext.cctvfootageReq")), 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "CCTVYes",
              value: "true",
              ref: "CCTVOption",
              disabled: _ctx.initModel.isDisabled,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newUser.CCTVDetailsRequired) = $event)),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearInputFieldsCCTV && _ctx.clearInputFieldsCCTV(...args)))
            }, null, 40, _hoisted_9), [
              [_vModelRadio, _ctx.newUser.CCTVDetailsRequired]
            ]),
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("labeltext.yesText")), 1)
          ]),
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "CCTVNo",
              value: "false",
              disabled: _ctx.initModel.isDisabled,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newUser.CCTVDetailsRequired) = $event)),
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearInputFieldsCCTV && _ctx.clearInputFieldsCCTV(...args)))
            }, null, 40, _hoisted_12), [
              [_vModelRadio, _ctx.newUser.CCTVDetailsRequired]
            ]),
            _hoisted_13,
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("labeltext.noText")), 1)
          ])
        ])
      ])
    ]),
    (_ctx.newUser.CCTVDetailsRequired.toString() === 'true')
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("labeltext.yesStoreVehicle")), 1),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "CCTVStore",
                    value: "true",
                    name: "cctvstorevehicle",
                    disabled: _ctx.initModel.isDisabled,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newUser.IsCCTVStore) = $event)),
                    onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clearInputFieldsStoreVehicle && _ctx.clearInputFieldsStoreVehicle(...args)))
                  }, null, 40, _hoisted_20), [
                    [_vModelCheckbox, _ctx.newUser.IsCCTVStore]
                  ]),
                  _hoisted_21,
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("labeltext.store")), 1)
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "CCTVCarPark",
                    value: "true",
                    name: "cctvstorevehicle",
                    disabled: _ctx.initModel.isDisabled,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newUser.IsCCTVCarPark) = $event)),
                    onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clearInputFieldsStoreVehicle && _ctx.clearInputFieldsStoreVehicle(...args)))
                  }, null, 40, _hoisted_23), [
                    [_vModelCheckbox, _ctx.newUser.IsCCTVCarPark]
                  ]),
                  _hoisted_24,
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("labeltext.carPark")), 1)
                ])
              ])
            ])
          ]),
          (
          _ctx.newUser.IsCCTVStore.toString() === 'true' ||
          (_ctx.newUser.IsCCTVCarPark && _ctx.newUser.IsCCTVCarPark.toString() === 'true')
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, [
                    _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("labeltext.storePostcode")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      disabled: _ctx.initModel.isDisabled,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newUser.StorePostCode) = $event)),
                      placeholder: 
                _ctx.initModel.isDisabled == true
                  ? ''
                  : _ctx.translate('labeltext.storePostcode')
              ,
                      name: "storepostcode",
                      style: {"max-width":"45% !important"}
                    }, null, 8, _hoisted_30), [
                      [_vModelText, _ctx.newUser.StorePostCode]
                    ]),
                    _createElementVNode("span", _hoisted_31, [
                      _createElementVNode("i", _hoisted_32, [
                        _createTextVNode("i "),
                        _createVNode(_component_v_tooltip, {
                          activator: "parent",
                          location: "bottom",
                          width: "320px",
                          contained: true,
                          "open-on-click": true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate("labeltext.storePostCodeTooltip")), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("labeltext.dateOfVisit")), 1),
                    _createVNode(_component_date_picker, {
                      placeholder: 
                _ctx.initModel.StoreDateofvisit == '' && _ctx.initModel.isDisabled
                  ? '  '
                  : _ctx.translate('labeltext.selectDatePlc')
              ,
                      modelValue: _ctx.initModel.StoreDateofvisit,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.initModel.StoreDateofvisit) = $event)),
                      disabled: _ctx.initModel.isDisabled,
                      locale: _ctx.initModel.datepickerLang,
                      "enable-time-picker": false,
                      format: _ctx.dateFormat,
                      "auto-apply": "",
                      "hide-input-icon": "",
                      name: "storedateofvisit"
                    }, null, 8, ["placeholder", "modelValue", "disabled", "locale", "format"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("label", _hoisted_37, [
                    _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t("labeltext.startTimeOfVisit")), 1),
                    _createElementVNode("div", _hoisted_39, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.initModel.storeStartHourOfVisit) = $event)),
                        disabled: _ctx.initModel.isDisabled,
                        name: "starthourofvisit"
                      }, [
                        _createElementVNode("option", _hoisted_41, _toDisplayString(_ctx.$t("labeltext.hour")), 1),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (item, index) => {
                          return _createElementVNode("option", { key: index }, _toDisplayString(index.toLocaleString("en-US", {
                      minimumIntegerDigits: 2,
                      useGrouping: false,
                    })), 1)
                        }), 64))
                      ], 8, _hoisted_40), [
                        [_vModelSelect, _ctx.initModel.storeStartHourOfVisit]
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.initModel.storeStartMinuteOfVisit) = $event)),
                        disabled: _ctx.initModel.isDisabled,
                        name: "startminuteofvisit"
                      }, [
                        _createElementVNode("option", _hoisted_43, _toDisplayString(_ctx.$t("labeltext.minute")), 1),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(60, (item, index) => {
                          return _createElementVNode("option", { key: index }, _toDisplayString(index.toLocaleString("en-US", {
                      minimumIntegerDigits: 2,
                      useGrouping: false,
                    })), 1)
                        }), 64))
                      ], 8, _hoisted_42), [
                        [_vModelSelect, _ctx.initModel.storeStartMinuteOfVisit]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("label", _hoisted_45, [
                    _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t("labeltext.endTimeOfVisit")), 1),
                    _createElementVNode("div", _hoisted_47, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.initModel.storeEndHourOfVisit) = $event)),
                        disabled: _ctx.initModel.isDisabled,
                        name: "endhourofvisit"
                      }, [
                        _createElementVNode("option", _hoisted_49, _toDisplayString(_ctx.$t("labeltext.hour")), 1),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (item, index) => {
                          return _createElementVNode("option", { key: index }, _toDisplayString(index.toLocaleString("en-US", {
                      minimumIntegerDigits: 2,
                      useGrouping: false,
                    })), 1)
                        }), 64))
                      ], 8, _hoisted_48), [
                        [_vModelSelect, _ctx.initModel.storeEndHourOfVisit]
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.initModel.storeEndMinuteOfVisit) = $event)),
                        disabled: _ctx.initModel.isDisabled,
                        name: "endminuteofvisit"
                      }, [
                        _createElementVNode("option", _hoisted_51, _toDisplayString(_ctx.$t("labeltext.minute")), 1),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(60, (item, index) => {
                          return _createElementVNode("option", { key: index }, _toDisplayString(index.toLocaleString("en-US", {
                      minimumIntegerDigits: 2,
                      useGrouping: false,
                    })), 1)
                        }), 64))
                      ], 8, _hoisted_50), [
                        [_vModelSelect, _ctx.initModel.storeEndMinuteOfVisit]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("label", _hoisted_53, [
                    _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t("labeltext.additionalInfoReqd")), 1),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newUser.AdditionalInfoReqd) = $event)),
                      placeholder: 
                _ctx.initModel.isDisabled == true
                  ? ''
                  : _ctx.translate('labeltext.additionalInfoReqdPlaceholder')
              ,
                      disabled: _ctx.initModel.isDisabled,
                      name: "addinfo",
                      maxlength: "100",
                      rows: "3"
                    }, null, 8, _hoisted_55), [
                      [_vModelText, _ctx.newUser.AdditionalInfoReqd]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
          _ctx.newUser.IsCCTVCarPark && _ctx.newUser.IsCCTVCarPark.toString() === 'true'
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("label", _hoisted_58, [
                    _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t("labeltext.vehicleMake")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newUser.VehicleMake) = $event)),
                      disabled: _ctx.initModel.isDisabled,
                      placeholder: 
                _ctx.initModel.isDisabled == true
                  ? ''
                  : _ctx.translate('labeltext.vehicleMake')
              ,
                      name: "vehiclemake",
                      maxlength: "25"
                    }, null, 8, _hoisted_60), [
                      [_vModelText, _ctx.newUser.VehicleMake]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("label", _hoisted_62, [
                    _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.$t("labeltext.model")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newUser.Model) = $event)),
                      disabled: _ctx.initModel.isDisabled,
                      placeholder: 
                _ctx.initModel.isDisabled == true
                  ? ''
                  : _ctx.translate('labeltext.model')
              ,
                      name: "vehiclemodel",
                      maxlength: "25"
                    }, null, 8, _hoisted_64), [
                      [_vModelText, _ctx.newUser.Model]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("label", _hoisted_66, [
                    _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.$t("labeltext.colour")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newUser.Colour) = $event)),
                      disabled: _ctx.initModel.isDisabled,
                      placeholder: 
                _ctx.initModel.isDisabled == true
                  ? ''
                  : _ctx.translate('labeltext.colour')
              ,
                      name: "vehiclecolour",
                      maxlength: "25"
                    }, null, 8, _hoisted_68), [
                      [_vModelText, _ctx.newUser.Colour]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("label", _hoisted_70, [
                    _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.$t("labeltext.regNo")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newUser.RegistrationNumber) = $event)),
                      disabled: _ctx.initModel.isDisabled,
                      placeholder: 
                _ctx.initModel.isDisabled == true
                  ? ''
                  : _ctx.translate('labeltext.regNo')
              ,
                      name: "vehicleregnumber",
                      maxlength: "25"
                    }, null, 8, _hoisted_72), [
                      [_vModelText, _ctx.newUser.RegistrationNumber]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}